module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/ring.536920d6.jpg";